import moment from "moment";

export function calcExpDate ( 
    date: string, 
    duration: number, 
    frequency: "daily" | "weekly" | "monthly" | "annually" | string
): string {

    if(date.includes("/") && date.length === 10) {
        date = formatDateWithSlashes(date)
    }

    if(date.includes("-") && date.length === 10) {
        date = formatDateWithDash(date)
    }

    let dateToString = moment(new Date(date)).format("DD/MM/YYYY");
    let duoDate = moment(dateToString , "DD/MM/YYYY");
    let dateBegin = 1
    let durationPlan = duration - dateBegin
    let result

    switch (frequency) {
        case "daily":
            result = duoDate.add(durationPlan, "d");

            break;

        case "weekly":
            result = duoDate.add(durationPlan, "w");

            break;

        case "monthly":
            result = duoDate.add(durationPlan, "M");

            break;

        case "annually":
            result = duoDate.add(durationPlan, "y");
            
            break;
    }

    
    return duoDate.format("DD/MM/YYYY")
}

const formatDateWithSlashes = (date: string): string => {
    const year = 4

        let splitDate = date.split("/")

        if(splitDate[0].length === year) {
            date = splitDate[1] + "/" + splitDate[2] + "/" + splitDate[0] 
        }

        else {
            date = splitDate[1] + "/" + splitDate[0] + "/" + splitDate[2] 
        }

    return date
}

const formatDateWithDash = (date: string): string => {
    const year = 4

        let splitDate = date.split("-")

        if(splitDate[0].length === year) {
            date = splitDate[1] + "/" + splitDate[2] + "/" + splitDate[0] 
        }

        else {
            date = splitDate[1] + "/" + splitDate[0] + "/" + splitDate[2] 
        }

    return date
}